<template>
  <div class="">
    <PreLoader v-if="isLoading" />
    <ExceptionWithImg v-if="exceptionMsg" :msg="exceptionMsg" />

    <PaymentForm
      v-if="!isLoading"
      :paymentData="paymentData"
      :submitName="$t('add')"
      v-on:addPayment="addPayment"
    />
  </div>
</template>

<script>
import PreLoader from "@/components/general/PreLoader.vue";
import ExceptionWithImg from "@/components/general/ExceptionWithImg.vue";
import { STATUS } from "@/utils/constants";
import PaymentForm from "@/components/reservations/payments/PaymentForm.vue";
import Payment from "@/models/reservations/payments/Payment";
import createToastMixin from "@/utils/create-toast-mixin";

export default {
  name: "PaymentAdd",
  mixins: [createToastMixin],
  components: {
    PreLoader,
    ExceptionWithImg,
    PaymentForm,
  },
  data() {
    return {
      isClient: false,
      isLoading: false,
      exceptionMsg: null,
      exceptionImg: null,
      language: localStorage.getItem("userLanguage") || "ar",
      userAuthorizeToken:
        this.$store.getters.userData.userPersonalData.userAuthorizeToken ||
        null,
      paymentData: new Payment(),
    };
  },
  methods: {
    async setUserType() {
      if (this.$store.getters.userData.clientPersonalData) {
        this.isClient = true;
      }
    },
    async addPayment() {
      this.isLoading = true;
      // if (this.isClient) {
      //   this.payments.filterData.clientToken =
      //     this.$store.getters.userData.clientPersonalData.clientToken;
      // }
      try {
        let response = await this.paymentData.addNewPayment(
          this.language,
          this.userAuthorizeToken
        );
        if (response.data.status == STATUS.SUCCESS) {
          this.showMsg(response.data.msg, true);
          this.paymentData.setInitialValue();
          this.paymentData.placeToken = this.$route.params.placeToken;
        } else if (response.data.status == STATUS.INVALID_TOKEN) {
          this.showMsg(response.data.msg);
          this.$store.dispatch("logoutUser");
          this.$router.push("/").catch(() => {});
        } else {
          this.showMsg(response.data.msg);
        }
      } catch (e) {
        this.showMsg(this.$t("errorCatch"));
      }
      this.isLoading = false;
    },
  },
  async created() {
    this.setUserType();
  },
};
</script>

<style scoped lang="scss"></style>
